import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { appEnv } from '../../app.config';
import { ResponseModel } from '../models/response.model';

/** 
 * Service for AU states-related api calls.
 * 
 * Note: Placing this in core module because it has possibilites to be used in multiple modules.
 */
@Injectable({
  providedIn: 'root'
})
export class StateService {
  constructor(private httpClient: HttpClient) { }

  /**
   * Api for getting the list of states.
   * Restricted to AU states only.
   * @returns Observale<any>
   */
  public getStateList(): Observable<ResponseModel> {
    return this.httpClient.get<ResponseModel>(`${appEnv.api}state`);
  }
}
